import React from "react";

// react-router components
import { Routes, Route, Navigate } from "react-router-dom";

// Material Dashboard 2 React routes
import routes from "routes";

// Protected route component
import ProtectedRoute from "components/ProtectedRoute";
import PublicRoute from "components/PublicRoute";

// Layout components
import MainLayout from "layouts/MainLayout";
import LayoutWrapper from "components/LayoutWrapper";
export default function App() {
  const getRoutes = (allRoutes) =>
    allRoutes
      .map((route) => {
        if (route.collapse) {
          return getRoutes(route.collapse);
        }

        if (route.route) {
          const isPublic = route.route.startsWith("/authentication");
          const isRestricted = route.route.startsWith("/authentication/sign-in") ||
            route.route.startsWith("/authentication/sign-up");

          return (
            <Route
              exact
              path={route.route}
              element={
                <LayoutWrapper>
                  {isPublic ? (
                    <PublicRoute restricted={isRestricted}>
                      {route.component}
                    </PublicRoute>
                  ) : (
                    <ProtectedRoute requiredRole={route.requiredRole}>
                      {route.component}
                    </ProtectedRoute>
                  )}
                </LayoutWrapper>
              }
              key={route.key}
            />
          );
        }

        return null;
      })
      .filter(Boolean)
      .flat();

  return (
    <MainLayout>
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
      </Routes>
    </MainLayout>
  );
}
